import script from "./custom-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./custom-modal.vue?vue&type=script&setup=true&lang=js"

import "./custom-modal.vue?vue&type=style&index=0&id=09f47310&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f47310"]])

export default __exports__